/***************
 * Developer :- Viraj Anil Gujar (#VAG)
 * Created Date :- Unknown
 * Updated Date :- 16/11/2023
 * Use :- API Configration
 ****************/

export const billingDetailUrl = () => {
    return process.env.REACT_APP_BILLING_DETAIL_URL;
};

export const billingEnquiryUrl = () => {
    return process.env.REACT_APP_UAT_BILLING_ENQUIRY_API;
};

export const sendEmailReceiptUrl = () => {
    return process.env.REACT_APP_SEND_EMAIL_RECEIPT_URL;
};

export const sessionID = () => {
    return process.env.REACT_APP_SESSION_ID;
};

export const oneIncPortalUrl = () => {
    return process.env.REACT_APP_ONE_INC_PORTAL_URL;
};

export const enrollToAutopayUrl = () => {
    return process.env.REACT_APP_ENROLL_TO_AUTOPAY;
};

export const unEnrollToAutopayUrl = () => {
    return process.env.REACT_APP_UNENROLL_TO_AUTOPAY;
};

export const saveBillingPaymentDetails = () => {
    return process.env.REACT_APP_SAVE_PAYMENT_DETAILS;
};

export const policyTokenUrl = () => {
    return process.env.REACT_APP_POLICY_TOKEN_URL;
};

export const SiteKey = () => {
    return process.env.REACT_APP_SITE_KEY;
};